import React, { useEffect } from "react";
import PageNavBar from "../Component/page/PageNavBar";
import { Container } from "react-bootstrap";
import {
  FilterMemberTable,
  SearchByIdTable,
} from "../Component/page/search/SearchTable";
import SearchField from "../Component/page/search/SearchField";
import ModernCard from "../Component/ModernCard";
import FilterField from "../Component/page/search/FilterField";
import { useSelector } from "react-redux";
import { selectOfficer } from "../features/chapter/slice";
import { selectUserEmail } from "../features/member/slice";
import { useNavigate } from "react-router-dom";
import { withAuthenticator } from "@aws-amplify/ui-react";

function Search() {
  const navigate = useNavigate();
  const isOfficer = useSelector(selectOfficer(useSelector(selectUserEmail)));

  useEffect(() => {
    if (!isOfficer) return navigate("/");
  });

  return (
    <div>
      <PageNavBar />
      <Container
        className="mt-5"
        style={{ maxWidth: "1200px", minHeight: "100vh" }}
      >
        <ModernCard title={"Search by Student ID"} minHeight={"40vh"}>
          <div className="">
            <SearchField />
            <SearchByIdTable />
          </div>
        </ModernCard>

        <ModernCard
          title={"Run Statistics"}
          subTitle={
            "Note: this query execution is relatively costly. Please only use this when it is necessary. "
          }
        >
          <FilterField />
          <FilterMemberTable />
        </ModernCard>
      </Container>
    </div>
  );
}

export default withAuthenticator(Search);
